/******************************************************
 *                  Credits Ctrl
 ********************************************************/

"use strict";

angular.module("admin")

	.controller("AdminCreditsCtrl", ["$scope", "toastr", "dashboard", function ($scope, toastr, dashboard) {

		/******************************************************
			 *                  SETUP
			 ********************************************************/
		$scope.data = {
			dashboard: dashboard.data
		};


	}]
	)
;
